export interface IItemsStyle {
  separator: ItemSeparatorKinds;
}

export enum ItemSeparatorKinds {
  None = 0,
  FullWidthPoint = 1,
  NewLine = 2,
  FullWidthToten = 3, // 読点はCommaだと区別が付かないのでローマ字で.
  FullWidthComma = 4,
  FullWidthSpace = 5,
}
